import { useState } from 'react';
import StatsWidgets from '@rio-cloud/rio-uikit/StatsWidgets';
import StatsWidget from '@rio-cloud/rio-uikit/StatsWidget';
import DataTabs from '@rio-cloud/rio-uikit/DataTabs';
import DataTab from '@rio-cloud/rio-uikit/DataTab';
import useScoreExtractStore from '../services/scoreExtractStore';
import { useNavigate } from 'react-router';
import { useSelectVehicleStore } from '../services/selectVehicleSlice';
import DashboardTableGoodPractices from '../features/dashboardTableGoodPractices/DashboardTableGoodPractices';
import TableViewToggles from '@rio-cloud/rio-uikit/components/table/TableViewToggles';
import DashboardTableAnalysis from '../features/dashboardTableAnalysis/DashBoardTableAnalysis';
import DashboardTableInfractions from '../features/dashboardTableInfractions/DashboardTableInfractions';
import { RouteMap } from '../routes/routeList';
import DashboardTableComingSoon from '../features/dashboardTableComingSoon/DashboardTableComingSoon';


const Title = ({ text, icon, value }: { text: string; icon: React.ReactNode, value: React.ReactNode }) => (
    <div>
        <div>{text}</div>
        <div className='text-bold text-size-18'><span className={`rioglyph ${icon} margin-right-10`}></span>{value}</div>
    </div>
);

export default function SafeDriving() {

    const [tabKey, setTabKey] = useState<string>('');
    const { clearExtractScoreData } = useScoreExtractStore();
    const navigate = useNavigate();
    const { selectedVehicle } = useSelectVehicleStore();
    const { clearSelectedVehicle } = useSelectVehicleStore();
    const behaviorType = 'SAFE';
    const behaviorRoute = `/${RouteMap.get('behavior')}`;

    const tabs = [
        {
            key: 'IT_EXTRACT',
            icon: 'rioglyph-clipboard',
            title: 'Direção segura',
            value: 'Análise por Evento',
            hasData: true
        },
        {
            key: 'IT_SPEED',
            icon: 'rioglyph-speed',
            title: 'Velocidade',
            value: `${selectedVehicle.itSpeed || 0} Ocorrências`,
            hasData: selectedVehicle.itSpeed ? Number(selectedVehicle.itSpeed) > 0 : false
        },
        {
            key: 'IT_ATTENTIVE_DRIVING',
            icon: 'rioglyph-status-driving',
            title: 'Condução',
            value: `${selectedVehicle.itAttentiveDriving || 0} Ocorrências`,
            hasData: selectedVehicle.itAttentiveDriving ? Number(selectedVehicle.itAttentiveDriving) > 0 : false
        },
        {
            key: 'IT_BRAKING',
            icon: 'rioglyph-brake',
            title: 'Frenagem',
            value: `${selectedVehicle.itBraking || 0} Ocorrências`,
            hasData: selectedVehicle.itBraking ? Number(selectedVehicle.itBraking) > 0 : false
        },
        {
            key: 'IT_ROLLOVER',
            icon: 'rioglyph-truck-breakdown',
            title: 'Condição de Estabilidade',
            value: `${selectedVehicle.itRollover || 0} Ocorrências`,
            hasData: selectedVehicle.itRollover ? Number(selectedVehicle.itRollover) > 0 : false
        },
        {
            key: 'IT_COASTING',
            icon: 'rioglyph-coasting',
            title: 'Aproveitamento de Inércia',
            value: `${selectedVehicle.itCoasting || 0} Ocorrências`,
            hasData: selectedVehicle.itCoasting ? Number(selectedVehicle.itCoasting) > 0 : false
        },
        {
            key: 'IT_GOOD_PRACTICES',
            icon: 'rioglyph-thumbs-up',
            title: 'Cuidados com o veículo',
            value: `${selectedVehicle.itGoodPractices || 0} Ocorrências`,
            hasData: selectedVehicle.itGoodPractices ? Number(selectedVehicle.itGoodPractices) > 0 : false
        }
    ];

    return (
        <StatsWidgets>
            <StatsWidget>
                <StatsWidget.Header className='text-left text-size-16'>
                    <ul className="breadcrumb">
                        <li>
                            <span className="btn btn-link btn-link-inline">
                                <span className="rioglyph rioglyph-home margin-right-0">
                                </span>
                                <span className='margin-left-10'>
                                    <a onClick={() => {
                                        clearExtractScoreData();
                                        clearSelectedVehicle();
                                        navigate(behaviorRoute);
                                    }}>Comportamento</a>
                                </span>
                            </span>
                        </li>
                        <li className="active">Direção Seguraㅤ-ㅤ<span className='text-bold'>{selectedVehicle.name}</span></li>
                    </ul>
                </StatsWidget.Header>
                <StatsWidget.Body>
                    <DataTabs activeKey={tabKey} onSelectTab={newTabKey => setTabKey(newTabKey)} style={{ width: '100%' }}>
                        {tabs.map((tab, index) => {
                            if (index === 0) {
                                return (
                                    <DataTab key={index} active={true} tabKey={tab.key} title={<Title text={tab.value} icon={tab.icon} value={tab.title} />}>
                                        <DashboardTableAnalysis viewType={TableViewToggles.VIEW_TYPE_TABLE} behaviorType={behaviorType} />
                                    </DataTab>
                                )
                            } if (tab.key === 'IT_GOOD_PRACTICES') {
                                return (<DataTab key={index} tabKey={tab.key} title={<Title text={tab.value} icon={tab.icon} value={tab.title} />}>
                                    <DashboardTableGoodPractices
                                        viewType={TableViewToggles.VIEW_TYPE_TABLE} hasData={tab.hasData}
                                    />
                                </DataTab>)
                            } 
                            if (tab.key === 'IT_ATTENTIVE_DRIVING' || tab.key === 'IT_ROLLOVER' ) {
                                return (
                                <DataTab key={index} tabKey={tab.key} title={<Title text={tab.value} icon={tab.icon} value={tab.title} />}>
                                    <DashboardTableComingSoon headline={tab.title} />
                                </DataTab>
                                );
                            } else {
                                return (<DataTab key={index} tabKey={tab.key} title={<Title text={tab.value} icon={tab.icon} value={tab.title} />}>
                                    <DashboardTableInfractions
                                        viewType={TableViewToggles.VIEW_TYPE_TABLE} hasData={tab.hasData} infractionName={tab.key} tabName={tab.title}
                                    />
                                </DataTab>)
                            }
                        })}
                    </DataTabs>
                </StatsWidget.Body>
            </StatsWidget>
        </StatsWidgets>
    );
}